import { lazy } from "react";
import { authRoles } from "app/auth/authRoles";

const Dashboard1 = lazy(() => import("./dashboard1/Dashboard1"));

const dashboardRoutes = [
  {
    path: "/dashboard/",
    element: <Dashboard1 />,
    // auth: authRoles.admin,
  },
];

export default dashboardRoutes;
